<template>
  <TypeAhead
    v-model="searchString"
    src=""
    classes="typeahead-container"
    :placeholder="placeholder"
    :getResponse="getResponse"
    :onHit="onHit"
    :fetch="fetch"
    queryParamName=":keyword"
    :highlighting="highlighting"
    :render="render"
    :selectFirst="false"
    :minChars="2"
    :limit="10"
  ></TypeAhead>
</template>

<script>
import TypeAhead from "vue2-typeahead";

export default {
  props: ["placeholder"],
  components: {
    TypeAhead,
  },
  data() {
    return {
      searchString: "",
    };
  },

  methods: {
    highlighting: function (item, vue) {
      return item.toString().replace(vue.query, `<b>${vue.query}</b>`);
    },
    render(items) {
      return items.map(e => e.firstName + " " + e.lastName + " (" + e.email + ")");
    },
    getResponse: function (response) {
      console.log("repsonse", response);

      // Filter out deactivated
      return response.data.filter(e => !e.isDeactivated);
    },
    onHit(item, vue) {
      let current = vue.current;
      let selectedItem = vue.data[current];

      console.log("selectedItem", selectedItem);
      this.$emit("onHit", selectedItem);

      this.searchString = "";
    },
    fetch: function (/*url*/) {
      return this.$http.get(process.env.VUE_APP_API_BASE_URL + "/users?query=" + this.searchString);
    },
  },
};
</script>

<style lang="scss">
.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}
</style>